import React, { useMemo } from 'react';
import { Stack } from '@moda/om';
import { format } from 'date-fns';
import { formatPrice } from '@moda/portal-stanchions';
import { SiteCreditAttributes } from '../../hooks/useSiteCredits/siteCredits.rest';
import { Link } from '../Link';

import './Credit.scss';

interface Props {
  attributes: SiteCreditAttributes;
}

export const Credit: React.FC<Props> = ({ attributes }) => {
  const {
    created_at: createdAt,
    amount,
    order_number: orderNumber,
    currency_unit: currencyUnit
  } = attributes;
  const amountIsPositive = Number(amount) >= 0;
  const absoluteAmount = Math.abs(Number(amount));

  const description = useMemo(() => {
    if (!amountIsPositive && !orderNumber) return 'Credit deducted from account';
    else if (!amountIsPositive && orderNumber) return 'Credit applied to order';
    else return 'Credit added to account';
  }, [orderNumber, amountIsPositive]);

  return (
    <Stack space={2} justifyContent="space-between" direction="horizontal" className="Credit">
      <Stack justifyContent="space-between" direction="horizontal" space={2}>
        <span className="Credit__text--date">{format(new Date(createdAt), 'PP')}</span>
        <span className="Credit__text--description">
          {description}
          {orderNumber && (
            <Link className="Credit__order-link" to={`/account/orders/${orderNumber}`}>
              #{orderNumber}
            </Link>
          )}
        </span>
      </Stack>
      <span className="Credit__text--amount">
        {amountIsPositive ? '+' : '-'} {formatPrice(currencyUnit, absoluteAmount)}
      </span>
    </Stack>
  );
};
